<template>
  <div class="bottom-navigation" style="margin-top: 156px">
    <div class="bottom-help" v-if="isHelp">
      <ul class="help-ul display-flex">
        <li
          class="display-flex"
          v-for="(item, index) in helpList"
          :key="item.id"
          @click="goRoute(item)"
        >
          <div class="help-li-box display-flex">
            <img :src="item.img" />
          </div>
          <span>{{ langData.helpList[index].text }}</span>
        </li>
      </ul>
    </div>
    <div class="bottom-footer">
      <div
        class="footer-item"
        :class="{ service: index === 'service' }"
        v-for="(item, index) in footerData"
        :key="item.id"
      >
        <div class="item-title">{{ item.title }}</div>
        <div class="item-content">
          <div
            class="item-content-nav"
            v-for="nav in item.content"
            :key="nav.id"
            @click="goRouter(nav)"
          >
            <div class="content-nav">
              {{ nav.text }}
            </div>
            <div class="content-nav-children" v-if="nav.content">
              <div
                class="nav-children-content"
                v-for="el in nav.content"
                :key="el.id"
                @click="goRouter(el)"
              >
                {{ el.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-item-last">
        <div class="item-title">{{ langData.title }}</div>

        <div class="item-phone item-email">info@topsfilm.com</div>
        <div class="item-phone item-email">karen.topsgmbh@gmail.com</div>
        <div class="item-phone">+49 151 21021665 (Global headquarter)</div>
        <div class="item-phone">+86 21 54019811 (Asia Pacific headquarer)</div>
        <div class="item-address">
          <span>{{ langData.adress }}</span>
        </div>
        <div class="item-QRCode">
          <img :src="qrcode" />
        </div>
      </div>
    </div>
    <div class="footer-legal">
      <span>©2019 TOPS，Inc。版权所有 沪ICP备19009252号-1</span>
    </div>
  </div>
</template>

<script>
import { footerData } from "../../config/dictionary.js";
import qrcode from "@/assets/img/public/qrcode.png";
import icon4 from "@/assets/img/top/top-4.png";
import icon5 from "@/assets/img/top/top-5.png";
import icon6 from "@/assets/img/top/top-6.png";
export default {
  name: "BottomNavigation",
  props: {
    isHelp: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      footerData: footerData,
      qrcode: qrcode,
      helpList: [
        {
          id: "help-1",
          text: "找到您附近的TOPS拓弗勒经销商→",
          src: "/Query/Distributor",
          img: icon4,
        },
        {
          id: "help-2",
          text: "查询车辆贴膜报价→",
          src: "",
          img: icon5,
        },
        {
          id: "help-3",
          text: "成为经销商→",
          src: "",
          img: icon6,
        },
      ],
    };
  },
  computed: {
    langEn() {
      return this.$store.state.dynamic.lang === "en";
    },
    langData() {
      return this.$t("bottomNavigation");
    },
  },
  methods: {
    goRouter(item) {
      debugger;
      if (this.$route.path.includes("/Case") && item.src === "/Case")
        this.$route.meta.scroll = true;
      this.$emit("case-change", item.code);
      const tempRouter =
        item.src === "/Case"
          ? { path: item.src + "/" + item.code }
          : { path: item.src };
      this.$router.push(tempRouter);
    },
    goRoute(item) {
      if (!item.src) return;
      this.$router.push({
        path: item.src,
      });
    },
  },
};
</script>
<style lang="css" scoped>
/*底部样式*/
.bottom-navigation .bottom-footer {
  display: flex;
  justify-content: space-between;
  background: #1e1e1e;
  box-sizing: border-box;
  padding: 62px 140px 74px 140px;
  color: #ffffff;
}

.bottom-navigation .bottom-help {
  width: 100%;
  height: 60px;
  background: #fed209;
}

.bottom-navigation .bottom-help .help-ul {
  height: 100%;
  width: 1200px;
  margin: 0 auto;
  justify-content: space-between;
}

.bottom-navigation .bottom-help .help-ul li {
  justify-content: space-between;
  cursor: pointer;
}

.bottom-navigation .bottom-help .help-ul li .help-li-box {
  width: 24px;
  height: 24px;
  background: #000000;
  border-radius: 50%;
  overflow: hidden;
}

.bottom-navigation .bottom-help .help-ul li span {
  height: 16px;
  font-size: 16px;
  line-height: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  margin-left: 8px;
}

/* .bottom-navigation .bottom-footer .footer-item {
  margin-right: 122px;
}

.bottom-navigation .bottom-footer .footer-item:first-child {
  margin-right: 72px;
} */

.bottom-navigation .bottom-footer .footer-item:last-child {
  margin-right: 0;
}

.bottom-navigation .bottom-footer .footer-item .item-title {
  height: 16px;
  line-height: 16px;
  font-size: 16px;
  font-family: PingFang;
  font-weight: 500;
  color: #ffffff;
  padding-bottom: 8px;
}

.bottom-navigation .bottom-footer .footer-item.service {
  margin-left: -50px;
}

.bottom-navigation .bottom-footer .footer-item.service .item-content {
  max-width: 243px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.service .item-content .item-content-nav,
.service .item-title {
  padding-left: 50px;
}

.service .item-content .item-content-nav:last-child {
  padding-left: 78px;
}

.bottom-navigation .bottom-footer .footer-item .item-content-nav,
.bottom-navigation .bottom-footer .footer-item .nav-children-content {
  /* height: 14px; */
  font-size: 13px;
  font-family: PingFang;
  font-weight: 400;
  color: #ffffff;
  line-height: 14px;
  opacity: 0.7;
  margin-top: 20px;
  cursor: pointer;
}

.bottom-navigation
  .bottom-footer
  .footer-item
  .item-content-nav
  .content-nav.solution {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #ffffff;
  line-height: 16px;
  cursor: default;
}

.bottom-navigation .bottom-footer .footer-item-last .item-title {
  height: 16px;
  font-size: 16px;
  line-height: 16px;
  font-family: PingFang;
  font-weight: 400;
  color: #ffffff;
  text-align: left;
}

.bottom-navigation .bottom-footer .footer-item-last .item-phone {
  /* height: 30px; */
  font-size: 13px;
  font-family: PingFang;
  font-weight: 400;
  color: #ffffff;
  line-height: 14px;
  opacity: 0.7;
  margin-top: 20px;
  cursor: pointer;
}
/* .bottom-navigation .bottom-footer .footer-item-last .item-email {
  font-size: 20px;
} */
.bottom-navigation .bottom-footer .footer-item-last .item-address {
  width: 100%;
  height: 30px;
  text-align: right;
  margin-top: 20px;
}

.bottom-navigation .bottom-footer .footer-item-last .item-address span {
  display: inline-block;
  width: 248px;
  height: 30px;
  font-size: 14px;
  font-family: PingFang;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.7;
  text-align: right;
}

.bottom-navigation .bottom-footer .footer-item-last .item-QRCode {
  width: 100%;
  height: 70px;
  margin-top: 20px;
  margin-left: -180px;
  text-align: right;
}

.bottom-navigation .bottom-footer .footer-item-last .item-QRCode img {
  width: 71px;
  height: 100%;
}

.bottom-navigation .footer-legal {
  width: 100%;
  height: 70px;
  line-height: 70px;
  text-align: center;
  background-color: #1e1e1e;
  margin-top: 2px;
}

.bottom-navigation .footer-legal span {
  height: 15px;
  line-height: 15px;
  font-size: 14px;
  font-family: PingFang;
  font-weight: 400;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/BottomNavigation.vue